<template>
  <div class="z-50">
    <div class="flex items-center">
      <!-- Category Badge -->
      <div class="relative inline-flex items-center mb-1 -ml-2 px-2 py-1 uppercase rounded-md text-xs leading-4"
           :class="[styleVariables.categoryBadgeStyles]"
           @mouseenter="showSeenButton = true" @mouseleave="showSeenButton=false">
        <p>
          <span v-if="showSeenButton && isNew" class="cursor-pointer" @click.prevent="markAsSeen">mark as seen</span>
          <span v-else>{{ this.mutableNotification.category }}</span>
        </p>
        <!-- New Notification Indicator -->
        <span v-if="isNew" class="border-white rounded-full absolute bg-green-400 w-3 h-3 text-center border-2 block border-white" style="top:-5px; right: -5px"></span>
      </div>
    </div>

    <!-- Main Summary Text-->
    <p class="text-xs block leading-5" :class="[styleVariables.summaryTextStyles]">
      {{ mutableNotification.summary }}
    </p>

    <!-- Tags If applicable-->
    <div v-if="mutableNotification.tags">
      <div v-for="tag in mutableNotification.tags"
           class="inline-flex items-center items-center mr-2 py-1 text-xs font-medium leading-4"
           :class="[styleVariables.tagAndSeeMoreTextStyles]">
        <svg width="8" height="8">
          <circle cx="3" cy="4" r="3" fill="currentColor"></circle>
        </svg>
        <span class="pb-0.5">{{ tag }}</span>
      </div>
    </div>

    <!-- Time and See more link-->
    <div class="mt-1 pr-2 text-xs leading-4 flex justify-between items-center">
      <span :class="[styleVariables.dateStyles]">
        {{ this.mutableNotification.relative_time }}
      </span>
      <a v-if="mutableNotification.has_more_detail"
         href="#"
         @click.prevent="showInModalWindow"
         class="whitespace-nowrap font-medium hover:text-indigo-600 transition ease-in-out duration-150"
         :class="[styleVariables.tagAndSeeMoreTextStyles]">
        See More &rarr;
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "SystemNotificationListItem",
  props: {
    notification: {
      type: Object,
      required: true,
    }
  },
  data () {
    return {
      mutableNotification: this.notification,
      showSeenButton: false,
    };
  },
  created () {
    let self = this;
    Bus.$on("notification-updated", function (notification) {
      if (notification.pivot.id === self.mutableNotification.pivot.id) {
        self.mutableNotification = notification;
      }
    });
    Bus.$on("mark-as-seen", function (notification) {
      if (notification.pivot.id === self.mutableNotification.pivot.id) {
        self.markAsSeen();
      }
    });
  }, computed: {
    isNew () {
      return this.mutableNotification.pivot.status == "new";
    },
    styleVariables () {
      let color = this.getColorForCategory(this.mutableNotification.category);
      let isNew = this.mutableNotification.pivot.status === "new";
      return {
        categoryBadgeStyles: isNew ? `bg-${color}-100 text-${color}-800 font-extrabold` : `bg-${color}-50 text-${color}-400 font-medium`,
        summaryTextStyles: isNew ? `text-gray-800 font-medium` : `text-gray-300 font-normal`,
        tagAndSeeMoreTextStyles: isNew ? `text-blue-500` : `text-blue-300`,
        dateStyles: isNew ? `text-gray-500` : `text-gray-300`
      };
    }
  },
  methods: {
    getColorForCategory (category) {
      switch (category) {
        case "bug report":
        case "bug fix":
          return "red";
        case "new feature":
        case "enhancement":
          return "green";
        case "notice":
          return "yellow";
        case "announcement":
          return "blue";
        default:
          return "indigo";
      }
    },
    markAsSeen () {
      App.patch("/system-notifications/" + this.mutableNotification.pivot.id + "/update", new AppForm({
        status: "seen"
      })).then(() => {
        this.mutableNotification.pivot.status = "seen";
      }).catch((errors) => {
        toastr.error("Could not mark this notification as seen!");
      });
    },
    showInModalWindow () {
      this.$emit("show-in-notification-modal", this.mutableNotification);
    },
  }
};
</script>

<style scoped>
</style>
